import { getUser, updatePassword } from '@/api/user'

export default {
    components: {
    },
    props: {
        showPasswordForm: {
            type: Boolean,
            required: true
        },
        model: {
            type: Object,
            default: () => null
        }
    },
    data () {
        return {
            labelCol: { span: 4 },
            wrapperCol: { span: 18 },
            loading: false,
            rules: {
                password_original: [ { required: true, message: '请输入原始密码', trigger: 'change' }],
                password: [ { required: true, message: '请输入新密码', trigger: 'change' }],
                password_confirmation: [ { required: true, message: '请再次输入新密码', trigger: 'change' }],
            }
        }
    },
    computed: {
        actType() {
            return this.model.id ? '修改' : '添加'
        }
    },
    mounted () {
    },
    methods: {
        submit() {
            this.$refs.form.validate(valid => {
                if (!valid) {
                    return false
                }
                this.storeOrUpdate()
            });
        },
        storeOrUpdate() {
            this.loading = true
            updatePassword(this.model).then(res => {
                this.$message.destroy()
                if (res && res.code === 0) {
                    this.$message.success('修改成功')
                    this.$emit('success')
                    getUser()
                    this.close()
                } else {
                    this.$message.error(res.message);
                }
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        close() {
            this.$refs.form.resetFields()
            this.$emit('update:showPasswordForm', false)
        }
    }
}
